import React from "react";
import styled, { css } from "styled-components";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space from "../../../utils/space";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "m20.727 16.693-6.034 6.02a.997.997 0 0 1-1.4 0 .98.98 0 0 1 0-1.386L18.643 16l-5.34-5.326a.98.98 0 0 1 0-1.386.997.997 0 0 1 1.4 0l6.034 6.02a.974.974 0 0 1 0 1.386z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32"
};
var background = "backgroundDarkLight";
var backgroundDisabled = "background";
var StyledArrow = styled.button.withConfig({
  componentId: "sc-z2kasf-0"
})(function (_ref) {
  var $direction = _ref.$direction,
    theme = _ref.theme;
  return css(["padding:0;border:0;background:none;fill:", ";cursor:pointer;.icon{fill:", ";}&.slick-disabled{fill:", ";cursor:not-allowed;.icon{fill:", ";}}", ""], getColor(theme, background), getIconColor(theme, background), getColor(theme, backgroundDisabled), getIconColor(theme, backgroundDisabled, "low"), $direction === "left" && css(["margin-right:", ";svg{transform:rotate(180deg);}"], space(2)));
});
function ProductCardsSliderOrgArrow(_ref2) {
  var direction = _ref2.direction,
    onClick = _ref2.onClick,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement(StyledArrow, {
    onClick: onClick,
    className: className,
    $direction: direction
  }, /*#__PURE__*/React.createElement(ArrowSvg, null));
}
export default ProductCardsSliderOrgArrow;